import { forwardRef, useState } from 'react';

import { twMerge } from 'tailwind-merge';

import { Eye, EyeHidden } from '../../../assets';
import { Input } from '../input';
import { IInputProps } from '../input/types';

export const PasswordInput = forwardRef<HTMLInputElement, IInputProps>(
  (
    {
      placeholder = 'Password',
      value,
      variant = 'secondary',
      size = 'md',
      ...rest
    },
    ref,
  ) => {
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
      setIsPasswordVisible((prev) => !prev);
    };

    const mouseDownToEyeHandler = (
      event: React.MouseEvent<HTMLButtonElement>,
    ) => {
      event.preventDefault();
    };

    return (
      <Input
        placeholder={placeholder}
        value={value}
        type={isPasswordVisible ? 'text' : 'password'}
        autoComplete="off"
        variant={variant}
        size={size}
        ref={ref}
        afterIcon={
          <button
            onClick={togglePasswordVisibility}
            type="button"
            onMouseDown={mouseDownToEyeHandler}
            className={twMerge(
              'opacity-0 transition-opacity duration-300 hover:text-brand-500',
              Boolean(value) && 'opacity-100',
            )}
          >
            {isPasswordVisible ? (
              <EyeHidden className="!size-[22px] transition-colors duration-300" />
            ) : (
              <Eye className="!size-[22px] transition-colors duration-300" />
            )}
          </button>
        }
        {...rest}
      />
    );
  },
);
